import { bl_cms_website_branch_link_RowClass } from '../../../dbschema/bl_cms_website_branch_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class WebsiteBranchLinkContainerModel extends BaseContainerModel {
    bl_cms_website_branch_link: bl_cms_website_branch_link_RowClass = new bl_cms_website_branch_link_RowClass();
}